import { isEmpty } from 'lodash';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const ReactSelectUserCustomizableAttributes = ({
  options,
  placeholder,
  ...props
}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const { isLoading, data: asyncCustomizableAttributesOptions } = useQueryOnce({
    queryKey: ['backoffice_network_users_customizable_attributes_path'],
    queryFn: () =>
      axios
        .get(
          Routes.backoffice_network_users_customizable_attributes_path({
            network_id: currentNetwork.id,
            skip_double_select: true,
            format: 'json',
          }),
        )
        .then(({ data }) => data.select_format),
  });

  return (
    <ReactSelectInput
      {...props}
      options={isEmpty(options) ? asyncCustomizableAttributesOptions : options}
      placeholder={__('Select a field from the list')}
      isLoading={isLoading}
    />
  );
};

export default ReactSelectUserCustomizableAttributes;
